import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@teo/components';
import { useState, useEffect } from 'react';
import { axios } from '@/axios';
import { config } from '@/config';
import AddCompetence from './CreateFlow/AddCompetence';
import { ArrowLeft } from '@teo/components/icons';
import AddCompetenceList from '@/components/Competencies/CreateFlow/AddCompetenceList';

const AddCompetenceLP = ({
  setIsOpenCompetencies,
  isOpenCompetencies,
  node,
  setNewCompetencies,
  newCompetencies,
  competencies,
  refetchCompetencies,
  training,
  conditions = false,
  onSaveConditions = undefined,
}) => {
  const { t } = useTranslation();

  const [deleteList, setDeleteList] = useState([]);
  const [addList, setAddList] = useState([]);
  const [isOpenAddCompetencies, setIsOpenAddCompetencies] = useState(false);

  useEffect(() => {
    const deletedIds = new Set(deleteList.map((item) => item.competenceId));

    const result = [
      ...competencies.filter((item) => !deletedIds.has(item.competenceId)),
      ...addList.map((item) => ({
        ...item,
      })),
    ];
    setNewCompetencies(result);
  }, [addList, deleteList, competencies]);

  const commonObjects = (arr1, arr2) => {
    const competenceIds = new Set(arr2.map((item) => item.competenceId));

    return arr1.filter((item) => competenceIds.has(item.competenceId));
  };

  const handleSaveLp = async () => {
    try {
      if (addList?.length > 0) {
        await Promise.all(
          addList.map((el) =>
            axios.post(`${config.backend}/learningpathcompetences`, {
              learningpathId: node?.id,

              competenceId: el?.competenceId,
            })
          )
        );
      }
      if (deleteList?.length > 0) {
        const result = commonObjects(competencies, deleteList);
        await Promise.all(
          result.map((el) =>
            axios.delete(`${config.backend}/learningpathcompetence/${el.id}`)
          )
        );
      }
      refetchCompetencies();
      setIsOpenCompetencies(false);
    } catch (error) {
      console.error('Error saving:', error);
    }
  };

  const handleSaveTr = async () => {
    try {
      if (addList?.length > 0) {
        await Promise.all(
          addList.map((el) =>
            axios.post(`${config.backend}/trainingcompetences`, {
              trainingId: node?.trainingId,
              competenceId: el?.competenceId,
            })
          )
        );
      }
      if (deleteList?.length > 0) {
        const result = commonObjects(competencies, deleteList);
        await Promise.all(
          result.map((el) =>
            axios.delete(`${config.backend}/trainingcompetence/${el.id}`)
          )
        );
      }
      refetchCompetencies();
      setIsOpenCompetencies(false);
    } catch (error) {
      console.error('Error saving:', error);
    }
  };

  return (
    <div className="bg-white">
      <Modal isOpen={isOpenCompetencies}>
        <Modal.Header
          onClose={() => {
            setIsOpenCompetencies(false);
          }}
        >
          {!isOpenAddCompetencies ? (
            <h2 className="text-sm font-semibold">
              {conditions
                ? t('pages.learning_path.conditions.edit_conditions')
                : t('widgets.widget_competencies.edit_competencies')}
            </h2>
          ) : (
            <div className="flex items-center">
              <Button
                variant="text"
                onClick={() => setIsOpenAddCompetencies(false)}
              >
                <ArrowLeft className="h-5 w-5" />
              </Button>
              {t('pages.manage_competencies.add_competencies')}
            </div>
          )}
        </Modal.Header>
        {!isOpenAddCompetencies ? (
          <Modal.Body>
            <div className="mb-1 space-y-2 md:space-y-4">
              <AddCompetence
                title={
                  conditions
                    ? 'pages.learning_path.conditions.modal_title'
                    : training
                    ? 'pages.create_edit_course.competence_add.title_tr'
                    : 'pages.create_edit_course.competence_add.title_lp'
                }
                text={
                  conditions
                    ? 'pages.learning_path.conditions.modal_text'
                    : training
                    ? 'pages.create_edit_course.competence_add.text_tr'
                    : 'pages.create_edit_course.competence_add.text_lp'
                }
                info_text={
                  conditions
                    ? 'pages.learning_path.conditions.modal_info_text'
                    : training
                    ? 'pages.create_edit_course.competence_add.info_text_tr'
                    : 'pages.create_edit_course.competence_add.info_text_lp'
                }
                setDeleteList={setDeleteList}
                setAddList={setAddList}
                addList={addList}
                listCompetencies={newCompetencies}
                setIsOpenAddCompetencies={setIsOpenAddCompetencies}
              />
            </div>
          </Modal.Body>
        ) : (
          <Modal.Body>
            <AddCompetenceList
              setDeleteList={setDeleteList}
              deleteList={deleteList}
              setAddList={setAddList}
              addList={addList}
              oldCompetencies={competencies}
              listCompetencies={newCompetencies}
              setNewLesCompetencies={setNewCompetencies}
            />
          </Modal.Body>
        )}

        <Modal.Footer>
          <div className="flex w-full">
            <Button
              variant="ghost"
              onClick={() => {
                setIsOpenCompetencies(false);
              }}
            >
              {t('button.cancel')}
            </Button>
            <Button
              onClick={() => {
                if (conditions) {
                  onSaveConditions?.(newCompetencies);
                  setIsOpenCompetencies(false);
                } else if (training) {
                  handleSaveTr();
                } else {
                  handleSaveLp();
                }
              }}
              className="ml-auto"
            >
              {t('widgets.widget_competencies.save_competencies')}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddCompetenceLP;
